import FormattedMessage from 'I18n/components/FormattedMessage';
import { SocialShareDropdown } from './SocialShareDropdown';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useSocialShareList } from './SocialShareList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MobileSocialShareMenuOption = ({
  onShare,
  item
}) => {
  const handleOnShare = (type, url) => {
    onShare === null || onShare === void 0 || onShare(type, url);
    if (url) window.open(url, '_blank'); // XAVI: preventDefault in CardMenuIcon is preventing external links from opening. We will remove this once the menu is refactored to use the right components
  };
  const optionsList = useSocialShareList({
    item,
    onShare: handleOnShare,
    rowSpaceStyleProps: {
      paddingBlock: '300',
      paddingInline: '500'
    },
    renderShareRow: button => /*#__PURE__*/_jsx(View, {
      children: button
    })
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: optionsList.map((option, index) => {
      var _options;
      return option.label ? /*#__PURE__*/_jsx(AccordionItem, {
        paddingBlockStart: "300",
        paddingInline: "400",
        title: option.label,
        children: /*#__PURE__*/_jsx(View, {
          paddingBlock: "200",
          children: (_options = option.options) === null || _options === void 0 ? void 0 : _options.map((submenuOption, indexSubmenu) => /*#__PURE__*/_jsx(View, {
            children: submenuOption
          }, indexSubmenu))
        })
      }, index) : option;
    })
  });
};
export const SocialShareMenuOption = ({
  onShare,
  item,
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.share"
  })
}) => {
  const handleOnShare = (type, url) => {
    onShare === null || onShare === void 0 || onShare(type, url);
    if (url) window.open(url, '_blank'); // XAVI: preventDefault in CardMenuIcon is preventing external links from opening. We will remove this once the menu is refactored to use the right components
  };
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "-100",
    marginInlineStart: "-300",
    children: /*#__PURE__*/_jsx(SocialShareDropdown, {
      item: item,
      onShare: handleOnShare,
      shareButton: /*#__PURE__*/_jsx(SideNavItem, {
        iconRight: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-interactive-default",
          icon: RightIcon,
          marginInlineEnd: "-100",
          size: "100"
        }),
        title: /*#__PURE__*/_jsx(View, {
          inlineSize: "251px",
          paddingInlineStart: "300",
          children: shareButtonLabel
        }) // temporal solution to extend the button to full width of the menu. Will be fixed in when we refactor the menu component
      })
    })
  });
};
export default SocialShareMenuOption;